
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/solution-page",
      function () {
        return require("private-next-pages/solutions/solution-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/solution-page"])
      });
    }
  